// src/services/api/categories.js
import { apiClient } from './base';

export const createProductCategory = async (categoryData) => {
  try {
    const response = await apiClient.post('/product-categories', categoryData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProductCategories = async (params = {}) => {
  try {
    const response = await apiClient.get('/product-categories', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// New function to get child categories
export const getChildCategories = async (parentId = null) => {
  try {
    const params = parentId ? { parentId } : {};
    const response = await apiClient.get('/product-categories/children', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProductCategory = async (categoryId) => {
  try {
    const response = await apiClient.get(`/product-categories/${categoryId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateProductCategory = async (categoryId, categoryData) => {
  try {
    const response = await apiClient.put(`/product-categories/${categoryId}`, categoryData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteProductCategory = async (categoryId) => {
  try {
    const response = await apiClient.delete(`/product-categories/${categoryId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};